module.exports = __webpack_public_path__ + "static/media/ре.44a26244.mp3";